<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="650")
    yz-card
      yz-dialog-normal-header(title="Download Limit Exceeded" @close="closeDialog")
      yz-dialog-normal-content.pa-8
        .yz-body-2.yz-neutral-700--text
          div(v-if="downloadType === 'pdf'")
            span.font-semibold PDF download
            span &nbsp;is limited to a maximum of
            span.text-danger-500.font-semibold &nbsp;1 month (31 days)
          div(v-else)
            span.font-semibold CSV download
            span &nbsp;is limited to a maximum of
            span.text-danger-500.font-semibold &nbsp;1 year (365 days).
          div.mt-4 Please adjust your date range and try again.
      yz-dialog-normal-actions
        yz-btn(size="lg" label="Close" @click="closeDialog")
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean
    },
    downloadType: {
      type: String,
      default: null
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog() {
      this.showDialog = false
    }
  }
}
</script>
